// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"FormSubmissionContainer_formContainer__o1CbE"};